// extracted by mini-css-extract-plugin
export default {"overlay":"Modal-module__overlay__w_rT1","content":"Modal-module__content__aDJQu"};